jQuery(document).ready(function ($) {

	let dataTables = $(".data_table");

	dataTables.each(function () {
		$(this).DataTable({
			"lengthMenu": [[15, 25, 50, -1], [15, 25, 50, strings.all]], // Set length menu options
			"language": strings.language, // Set language for DataTable
		});
	});

	let table = dataTables.DataTable(),
		productGroups = $("#productgroepen");

	if (productGroups.length) {
		productGroups.on("change", function () {
			const searchValue = parseInt(this.value) === 0 ? "" : this.value + ";";

			table.columns(1).search(searchValue, true, true, false).draw();
		});

		// Set default value for product groups dropdown and trigger change event
		productGroups.val(strings.new).trigger("change");
	}
});